import { get } from '../client/axiosClient';
import { timezoneEndpoints } from '../endpoints/timezone.endpoints';
import type { ApiResponse, Timezone } from '../types';

class TimezoneService {
  async getAll(): Promise<ApiResponse<Timezone[]>> {
    const response = await get<any>(timezoneEndpoints.list());
    const raw = response.data;
    return { success: raw?.success ?? false, message: raw?.message, data: raw?.data ?? [] };
  }
}

export const timezoneService = new TimezoneService();
export default timezoneService;
